const countries = [
  {
    id: "CA",
    text: "Canada",
    value: "CA",
    continent: "North America",
    currencyId: "CAD",
    phoneCode: "1",
    flag: "🇨🇦",
  },
];

export default countries;



// WEBPACK FOOTER //
// ./src/consts/countries.js